<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { flexible } from './util/flexible'
export default {
  created() {
    flexible(window, document)
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

p {
  display: block;
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
</style>
